import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { PreparedCategoryData } from 'utils';
import { GAClickButton } from 'utils/analytics/analytics-events';
import { selectIsModalOpen, selectModalData } from '../selectors';
import { usePopularCategoriesSlice } from './use-popular-categories-slice';
import { selectIsSmallScreen } from '../../../../store/pageStore';

export const usePopularCategories = () => {
	const { closeModal, openModal, setModalData } = usePopularCategoriesSlice();

	const isModalOpen = useSelector(selectIsModalOpen);
	const modalData = useSelector(selectModalData);
	const isSmallScreen = useSelector(selectIsSmallScreen);

	const onCloseModalHandler = useCallback(() => {
		closeModal();
		GAClickButton({
			elementBlock: 'servicePage / modalForm',
			elementName: modalData.name,
			elementText: 'close',
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [modalData]);

	const setPSModalData = useCallback(
		(newData: PreparedCategoryData) => setModalData({ data: newData }),
		[setModalData]
	);
	return {
		onCloseModalHandler,
		openModal,
		isModalOpen,
		modalData,
		setModalData: setPSModalData,
		isSmallScreen,
	};
};
